export const serialize = (obj: Record<string, any>): string => {
  if (!obj) {
    return "";
  }
  return (
    "?" +
    Object.keys(obj)
      .reduce((a, k) => {
        if (obj[k] !== undefined) {
          if (Array.isArray(obj[k])) {
            for (let i = 0; i < obj[k].length; i++) {
              a.push(k + "[]=" + encodeURIComponent(obj[k][i]));
            }
          } else {
            a.push(k + "=" + encodeURIComponent(obj[k]));
          }
        }
        return a;
      }, [] as string[])
      .join("&")
  );
};
